import React, { useState } from 'react';
import { DatePicker, Input, OnboardingContainer } from '../../../components';
import {
  Content,
  Form,
  InvitationCodeWrapper,
  LinkText,
  StyledButton,
  Subtitle,
  TextContainer,
  Title,
} from './BasicInfoPage.styles';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { updateBasicInfo } from '../../../store/slices/influencerRequest/asyncThunks';
import { notifyError, notifyInfo } from '../../../utils/notify';
import { selectInfluencerRequestActionsPending } from '../../../store/slices/influencerRequest/slice';
import { Text14Light } from '../../../components/utils/Text/Text.styles';

export const updateBasicInfoFormSchema = yup
  .object({
    name: yup.string().trim().required('Name is required').max(255, 'Max length reached'),
    dateOfBirth: yup
      .date()
      .required('Birth of date is required')
      .max(new Date(new Date().setFullYear(new Date().getFullYear() - 18)), 'Influencer must be 18+'),
    instagramUsername: yup.string().trim().required('Instagram username is required').max(255, 'Max length reached'),
    // twitterUsername: yup.string().trim().required('X username is required').max(255, 'Max length reached'),
  })
  .required();

const BasicInfoPage = () => {
  const dispatch = useDispatch();
  const { updateBasicInfo: updateBasicInfoPending } = useSelector(selectInfluencerRequestActionsPending);
  const [hasInvitationCode, setHasInvitationCode] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      name: '',
      dateOfBirth: null,
      instagramUsername: '',
      twitterUsername: '',
      invitationCode: '',
    },
    delayError: 300,
    resolver: yupResolver(updateBasicInfoFormSchema),
  });

  const invitationCodeWatch = watch('invitationCode');

  const onSubmit = data => {
    dispatch(updateBasicInfo(data))
      .unwrap()
      .then(() => {
        notifyInfo('Basic info updated successfully');
      })
      .catch(err => {
        notifyError(err.message);
      });
  };

  return (
    <OnboardingContainer>
      <Content>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Title>Let’s get you set up!</Title>
          <Subtitle>Please enter details.</Subtitle>
          <Input label="Profile Name" placeholder="Enter name" {...register('name')} error={errors.name?.message} />
          <Controller
            name="dateOfBirth"
            control={control}
            render={({ field }) => {
              return (
                <DatePicker
                  label="Date of birth"
                  placeholder="Enter date of birth"
                  value={field.value}
                  onChange={field.onChange}
                  error={errors.dateOfBirth?.message}
                />
              );
            }}
          />
          <Input
            label="Instagram"
            placeholder="Enter your Instagram username"
            {...register('instagramUsername')}
            error={errors.instagramUsername?.message}
          />
          <Input
            label="X (Twitter)"
            placeholder="Enter your X Username"
            {...register('twitterUsername')}
            error={errors.twitterUsername?.message}
          />
          {hasInvitationCode && (
            <InvitationCodeWrapper>
              <Input
                label="Invite Code"
                placeholder="Enter Invite Code"
                {...register('invitationCode')}
                error={errors.invitationCode?.message}
              />
            </InvitationCodeWrapper>
          )}

          <StyledButton
            title={invitationCodeWatch.trim() ? 'Continue' : 'Join the Waitlist'}
            isLoading={updateBasicInfoPending}
          />
          {!hasInvitationCode && (
            <TextContainer>
              <Text14Light>Have an invite code?</Text14Light>
              <LinkText onClick={() => setHasInvitationCode(true)}>Skip the line</LinkText>
            </TextContainer>
          )}
        </Form>
      </Content>
    </OnboardingContainer>
  );
};

export default BasicInfoPage;
